import React, { useMemo } from 'react';
import { Box, Stack } from '@mui/material';

import { LayoutSlots } from '../types';
import { BulkActionsPanel } from './BulkActionsPanel';

interface Props<Context extends any = any> extends LayoutSlots<Context> {
  context: Context;
  table: React.ReactNode;
  selected?: string[];
}

const buildGridTemplateRows = (top: boolean, renderTop: boolean, renderBottom: boolean, bottom: boolean): string =>
  [top && 'auto', renderTop && 'auto', '1fr', renderBottom && 'auto', bottom && 'auto'].filter(Boolean).join(' ');

export const Layout = <Context extends any = any>({
  table,
  context,
  bulkActions,
  selected = [],
  actionPanelTop,
  ActionPanelTop,
  ActionPanelBottom,
  actionPanelBottom,
}: Props<Context>) => {
  const gridTemplateRows = useMemo(
    () => buildGridTemplateRows(!!ActionPanelTop, !!actionPanelTop, !!actionPanelBottom, !!ActionPanelBottom),
    [ActionPanelTop, ActionPanelBottom, actionPanelTop, actionPanelBottom]
  );

  return (
    <Stack gap="0.5rem" sx={{ height: '100%', minHeight: 0 }}>
      <Box sx={{ position: 'relative', display: 'grid', gridTemplateRows, flex: 1, minHeight: 0, gap: '0.5rem' }}>
        {ActionPanelTop && <ActionPanelTop context={context} />}
        {actionPanelTop && actionPanelTop({ context })}
        {table}
        {actionPanelBottom && actionPanelBottom({ context })}
        {ActionPanelBottom && <ActionPanelBottom context={context} />}

        {bulkActions && selected.length > 0 && (
          <Box sx={{ position: 'absolute', top: '-3rem', left: '0rem', right: '0rem', zIndex: 5 }}>
            <BulkActionsPanel context={context} selected={selected} bulkActions={bulkActions} />
          </Box>
        )}
      </Box>
    </Stack>
  );
};
